import { Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Stack, Typography, useTheme } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import Iconify from '../iconify';
import Scrollbar from '../scrollbar';

interface SidebarItem {
  label: string;
  path?: string | null;
  icon?: React.ReactNode;
  items?: SidebarItem[];
}

export const config: string = 'Configurações';
export const registerProfile: string = 'Consulta / Cadastro de perfil';
export const registerUser: string = 'Consulta / Cadastro de usuário';
export const notification: string = 'Notificações Push';
export const shoppingInfo: string = 'Atualização de Dados';
export const termsAndPolicies: string = 'Atualização de Termos e Políticas';
export const faq: string = 'Perguntas Frequentes';
export const store: string = 'Loja / Restaurante';
export const categories: string = 'Categoria';
export const events: string = 'Cadastrar / Editar Eventos';
// export const gastronomicTuesday: string = 'Terça Gastronômica';
export const services: string = 'Cadastrar / Editar Serviços';
export const parking: string = 'Editar Estacionamento';
export const home: string = 'Homepage';
export const inConcert: string = 'InConcert';
export const promotions: string = 'Promoções e Campanhas';
export const sellerCode: string = 'Configuração do Programa';
export const benefitsConfig: string = 'Configuração de Benefícios';

export const sidebarItems: SidebarItem[] = [
  {
    label: 'Dashboard',
    path: paths.dashboard.root,
    items: [
      {
        label: config,
        path: '/configuracoes',
        items: [
          {
            label: registerProfile,
            icon: <Iconify color="primary.main" icon="ri:user-3-line" height={32} width={32} />,
            path: paths.userProfile.root,
          },
          {
            label: registerUser,
            icon: <Iconify color="primary.main" icon="ri:user-3-line" height={32} width={32} />,
            path: paths.registerUser.root,
          },
        ],
      },
    ],
  },
  {
    label: 'APP',
    items: [
      {
        label: 'Informações do Shopping',
        items: [
          {
            label: home,
            icon: <Iconify color="primary.main" icon="ri:home-smile-line" height={32} width={32} />,
            path: paths.home.root,
          },
          {
            label: notification,
            icon: <Iconify color="primary.main" icon="ri:notification-3-line" height={32} width={32} />,
            path: paths.notification.root,
          },
          {
            label: shoppingInfo,
            icon: <Iconify color="primary.main" icon="ri:database-line" height={32} width={32} />,
            path: paths.shoppingInfo.root,
          },
          {
            label: termsAndPolicies,
            icon: <Iconify color="primary.main" icon="ri:file-text-line" height={32} width={32} />,
            path: paths.termsAndPolicies.root,
          },
          {
            label: faq,
            icon: <Iconify color="primary.main" icon="ri:question-answer-line" height={32} width={32} />,
            path: paths.faq.root,
          },
        ],
      },
      {
        label: 'Lojas / Restaurantes',
        items: [
          {
            label: store,
            icon: <Iconify color="primary.main" icon="ri:store-line" height={32} width={32} />,
            path: paths.stores.root,
          },
          {
            label: categories,
            icon: <Iconify color="primary.main" icon="ri:store-line" height={32} width={32} />,
            path: paths.storesRestaurantsCategories.root,
          },
        ],
      },
      {
        label: 'Eventos e Promoções',
        items: [
          {
            label: events,
            icon: <Iconify color="primary.main" icon="ri:calendar-check-line" height={32} width={32} />,
            path: paths.events.root,
          },
          // {
          //   label: gastronomicTuesday,
          //   icon: <Iconify color="primary.main" icon="ri:restaurant-2-line" height={32} width={32} />,
          //   path: paths.gastronomicTuesday.root,
          // },
          {
            label: inConcert,
            icon: <Iconify color="primary.main" icon="ri:music-2-line" height={32} width={32} />,
            path: paths.inConcert.root,
          },
          {
            label: promotions,
            icon: <Iconify color="primary.main" icon="ri:medal-2-line" height={32} width={32} />,
            path: paths.promotions.root,
          },
        ],
      },
      {
        label: 'Serviços',
        items: [
          {
            label: services,
            icon: <Iconify color="primary.main" icon="ri:store-line" height={32} width={32} />,
            path: paths.service.root,
          },
        ],
      },
      {
        label: 'Estacionamento',
        items: [
          {
            label: parking,
            icon: <Iconify color="primary.main" icon="ri:car-line" height={32} width={32} />,
            path: paths.parking.root,
          },
        ],
      },
      {
        label: 'Programa de Fidelidade',
        items: [
          {
            label: sellerCode,
            icon: <Iconify color="primary.main" icon="ri:settings-4-line" height={32} width={32} />,
            path: paths.sellerCode.root,
          },
          {
            label: benefitsConfig,
            icon: <Iconify color="primary.main" icon="ri:medal-line" height={32} width={32} />,
            path: paths.benefitsConfig.root,
          },
        ],
      },
    ],
  },
];

interface ContentProps {
  onClose?: () => void;
}

function Content({ onClose }: ContentProps) {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();

  const filteredItems = sidebarItems;

  return (
    <Stack m={3}>
      <Box
        onClick={() => {
          navigate(paths.dashboard.root);
          if (onClose) onClose();
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          cursor: 'pointer',
          height: 86,
        }}
      >
        <Box
          component="img"
          src="/logo/logo_completo.png"
          alt="Flamboyant Shopping"
          sx={{ width: 'auto', maxWidth: '100%', height: 86, objectFit: 'contain', objectPosition: 'left center', display: 'block' }}
        />
      </Box>
      <List>
        {filteredItems.map((section) => (
          <Box key={section.label}>
            <Typography
              typography="bold-hd-md"
              sx={{
                color: theme.palette.primary.main,
                cursor: section.path ? 'pointer' : 'default',
                mb: 3,
                mt: 5,
                px: 1,
              }}
              onClick={() => {
                navigate(section.path ?? '#');
                if (onClose) onClose();
              }}
            >
              {section.label}
            </Typography>

            {section.items?.map((subcategory) => (
              <Box key={subcategory.label} mb={2}>
                <Typography
                  sx={{
                    p: 1,
                    color: theme.palette.text.primary,
                    typography: 'bold-hd-xs',
                  }}
                >
                  {subcategory.label}
                </Typography>

                <Stack
                  spacing={2}
                  sx={{
                    p: 1,
                  }}
                >
                  {subcategory.items?.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <ListItemButton
                        key={item.label}
                        component={Link}
                        to={item.path || '#'}
                        sx={{ display: 'flex', alignItems: 'center', p: 0 }}
                        onClick={() => {
                          if (onClose) onClose();
                        }}
                      >
                        {item.icon && <ListItemIcon sx={{ color: theme.palette.primary.main }}>{item.icon}</ListItemIcon>}
                        <ListItemText
                          primary={item.label}
                          primaryTypographyProps={{
                            typography: isActive ? 'bold-bd-md' : 'body-md',
                            sx: {
                              color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
                            },
                          }}
                        />
                      </ListItemButton>
                    );
                  })}
                </Stack>
              </Box>
            ))}
          </Box>
        ))}
      </List>
    </Stack>
  );
}

interface SidebarProps {
  open?: boolean;
  onClose?: () => void;
  drawer?: boolean;
}

export default function Sidebar({ open = false, drawer = false, onClose }: Readonly<SidebarProps>) {
  return (
    <div data-testid="navigation">
      {drawer ? (
        <Drawer
          open={open}
          onClose={onClose}
          sx={{
            flexShrink: 1,
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              flexShrink: 1,
            },
          }}
        >
          <Content onClose={onClose} />
        </Drawer>
      ) : (
        <Box width="100%" height="100vh">
          <Scrollbar>
            <Content />
          </Scrollbar>
        </Box>
      )}
    </div>
  );
}
